import { Component } from '@angular/core';
import {Events, IonicPage, NavController, NavParams, PopoverController} from 'ionic-angular';
import {DatePickerPopoverPage} from "../date-picker-popover/date-picker-popover";
import * as moment from "moment";
import {ApiProvider} from "../../providers/api/api";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";

/**
 * Generated class for the AppStatsFoodUpdatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-stats-food-update',
  templateUrl: 'app-stats-food-update.html',
})
export class AppStatsFoodUpdatePage {

  selectOptions = {
    cssClass: "stats-input-popover-element"
  };
  selectedDateFormatted: any
  selectedDate: any
  selectedFood: any
  selectedCount: any = 1;
  errorVisible: boolean
  removeRecord: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private popoverCtrl: PopoverController,
    private apiProvider: ApiProvider,
    private events: Events,
    private contentTranslation: ContentTranslationProvider,
  ) {
    moment.updateLocale('de',function() {});
    this.selectedDateFormatted = moment().format('dd, ll')

    if(this.navParams.get('date')) {
      this.selectedDate = moment(this.navParams.get('date')).toDate();
      this.formatSelectedDate();
    }


  }
  formatSelectedDate() {
    // if(moment(this.selectedDate).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')) {
    //   this.selectedDateFormatted = this.contentTranslation.translateContent('Food today');
    // } else {
      this.selectedDateFormatted = moment(this.selectedDate).format('dd, ll')
    // }
  }

  updateFormattedDate(event) {
    this.selectedDate = event;
    this.formatSelectedDate();
  }
  hideError() {
    this.errorVisible = false;
  }


  openedPopover: any;
  openDatePickerPopover(event) {
    this.openedPopover = this.popoverCtrl.create(
      DatePickerPopoverPage,
      {
        pastDateSelect: true,
        valueUpdated: (selectedDate) => {
          this.selectedDate = moment(selectedDate).toDate();
          this.formatSelectedDate();
        }
      },
      {cssClass: 'date-picker-popover-container'}
    );
    this.openedPopover.present({
      ev: event,
    });
  }

  goNext() {
    if (!this.selectedFood || !this.selectedCount) {
      this.errorVisible = true;
      return;
    }

    this.apiProvider.callPut('/food/'+moment(this.selectedDate).format('YYYY-MM-DD'), {
      inputFood: this.selectedFood,
      inputCount: this.selectedCount*(this.removeRecord?-1:1)
    }).subscribe((data) => {
      this.events.publish('stats:food:update', {data})
      this.navCtrl.pop();
    })


  }


}



// WEBPACK FOOTER //
// ./src/pages/app-stats-food-update/app-stats-food-update.ts